// extracted by mini-css-extract-plugin
export default {"sidebarWrap":"BlogSlug_sidebarWrap__w5O94"};